import React, { useMemo } from 'react';

import type { Step } from '@/hooks';
import { StepsNavigation } from '@/components/ui/StepsNavigation';
import { DIRECTION } from '@/components/ui/StepsNavigation/types';
import { StepperWrapper } from './styles';
import type { EvaluationStep } from './types';

interface StepperProps {
	steps: EvaluationStep[];
	currentStep: number;
	reachedStep: number;
	complete: boolean;
	consolidated: boolean;
	onStepClick: (step: number) => void;
}

function toNavigationStep(step: EvaluationStep): Step {
	const result: Step = {
		id: step.id,
		name: step.name,
		sequence: step.sequence,
		description: step.description
	};

	return result;
}

export function Stepper({
	steps,
	currentStep,
	reachedStep,
	complete,
	consolidated,
	onStepClick
}: Readonly<StepperProps>): JSX.Element {
	const navigationSteps = useMemo(() => steps.map(toNavigationStep), [steps]);

	return (
		<StepperWrapper>
			<StepsNavigation
				steps={navigationSteps}
				isComplete={complete}
				currentStep={currentStep}
				reachedStep={reachedStep}
				isConsolidated={consolidated}
				direction={DIRECTION.HORIZONTAL}
				onStepNagivationClick={onStepClick}
			/>
		</StepperWrapper>
	);
}
